import { render, staticRenderFns } from "./WelfareForCalcList.vue?vue&type=template&id=65630722"
import script from "./WelfareForCalcList.vue?vue&type=script&lang=js"
export * from "./WelfareForCalcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports